export const FEATURE_FLAGS = {
  SERVICE_AUTHZ: 'enableServiceAuthZ',
  INCLUDE_HELIX_TECH_FAMILIES: 'IncludeHelixTechFamilies',
  INCLUDE_HELIX_SERVICES: 'IncludeHelixServices',
} as const;
